<template>
  <slot name="before"  />


  <div class="app-container"
       :class="[containerClass]"
  >
    <RouterView />

    <slot />
  </div>
  <slot name="after" />
</template>
<script setup>
import {useStore} from "vuex";
import {useRoute} from "vue-router";

const store = useStore();
const route = useRoute();

const props = defineProps({
  containerClass: [Array, String, Object],
});
</script>
<style lang="scss">
@import "@/css/functions";
@import "@/css/variables";

#app {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.app-container {
  width: 100%;
  height: 100%;
  position: relative;

  &--guest {
    overflow-y: auto;
  }

  &--admin {
    display: flex;
    flex-direction: column;

    .page {
      bottom: $footer-height;
      top: 0;
      height: auto !important;
    }
  }
}

.app-container.full-screen {
  .sidebar {
    transform: translateX(-100%);
  }

  .floating-panel {
    opacity: 0;
    &__container {
      pointer-events: none;
    }
  }

  .object-widgets,
  .history-dashboard {
    transform: translateY(100%);
    bottom: 0;
  }

  .map .map__controls {
    .map__controls-group--tools {
      display: none;
    }

    .map__controls-group--main .control:not(.show_traffic){
      height: 0;
      border: none;
      opacity: 0;
    }

    .map__controls-group--main .control.show_traffic .control__container {
      border-radius: $border-radius-lg;
    }
  }
}
</style>